"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferralRecipientStatus = void 0;
var ReferralRecipientStatus;
(function (ReferralRecipientStatus) {
    ReferralRecipientStatus["Sent"] = "SENT";
    ReferralRecipientStatus["SignedUp"] = "SIGNED_UP";
})(ReferralRecipientStatus || (exports.ReferralRecipientStatus = ReferralRecipientStatus = {}));
//# sourceMappingURL=referral.js.map